import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme'
import LocalizedString from 'ui/components/generic/LocalizedString'
import withTranslations from 'containers/withTranslations'
import { withRouter } from 'react-router'
import { compose } from 'react-apollo'
import Button from 'ui/components/generic/Button'

import Results from './Results'

class PressMaterials extends Component {
  state = {
    product: '',
    category: '',
    filterActive: false
  }

  updateFilters(change) {
    this.setState(state => ({
      ...state,
      ...change,
      filterActive: true
    }))
  }

  resetFilters() {
    this.setState({
      product: '',
      category: '',
      filterActive: false,
    })
  }

  render() {
    const {
      products,
      categories,
      showAllMaterials,
      translations,
    } = this.props

    const {
      product,
      category,
      filterActive
    } = this.state

    return (
      <Wrapper>
        <FilterWrapper>
          <Container fluid>
            <Row>
              <Col
                lg={10}
                lgOffset={1}
              >
                <Inner>
                  <Row>
                    <Col md={6}>
                      <Field>
                        <Label><LocalizedString group="pressMaterialLabels" string="product" /></Label>
                        <Select
                          onChange={e => this.updateFilters({ product: e.target.value || '' })}
                          value={product}
                        >
                          <option value="">{translations ? translations.pressMaterialPlaceholders.product : 'Select product'}</option>
                          {products.map(p =>
                            <option
                              value={p.slug}
                              key={p.slug}
                            >
                              {p.title}
                            </option>
                          )}
                        </Select>
                      </Field>
                    </Col>
                    <Col md={6}>
                      <Field>
                        <Label><LocalizedString group="pressMaterialLabels" string="category" /></Label>
                        <Select
                          onChange={e => this.updateFilters({ category: e.target.value || '' })}
                          value={category}
                        >
                          <option value="">{translations ? translations.pressMaterialPlaceholders.category : 'Select category'}</option>
                          {categories.map(c =>
                            <option
                            value={c.slug}
                            key={c.slug}
                            >
                              {c.title}
                            </option>
                          )}
                        </Select>
                      </Field>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Reset>
                        <Button
                          to="#"
                          hollow="true"
                          onClick={() => this.resetFilters()}
                        >
                          Reset
                        </Button>
                      </Reset>
                    </Col>
                  </Row>
                </Inner>
              </Col>
            </Row>
          </Container>
        </FilterWrapper>

        <Container fluid>
          <Results
            product={product}
            products={products}
            category={category}
            categories={categories}
            showAllMaterials={showAllMaterials}
            filterActive={filterActive}
          />
        </Container>
      </Wrapper>
    )
  }
}

export default compose(
  withRouter,
  withTranslations()
)(PressMaterials)

// Styles
const { colors } = theme

const Wrapper = styled.section`
  margin-bottom: 90px;
`

const FilterWrapper = styled.div`
  background-color: ${colors.tones.lightest};
  padding: 4rem 0;
  margin-bottom: 3rem;
`

const Inner = styled.div`
  padding: 30px 50px;
  background-color: ${colors.primary};
  color: #fff;
`

const Field = styled.div`
  margin-bottom: 40px;
`

const Label = styled.label`
  font-size: 12px;
  text-transform: uppercase;
`

const Select = styled.select`
  background: none;
  width: 100%;
  border: none;
  border-bottom: 1px solid white;
  appearance: none;
  border-radius: 0;
  color: ${colors.secondary};
  padding: 20px 10px;
  outline: none;
`

const Reset = styled.div`
  text-align: right;
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/PressMaterials/index.js